export enum ACTIONENDPOINT {
	ASSIGNED = 'assigned',
	ASSIGNED_TO_APPRAISER = 'assigned-to-appraiser',
	REVISION = 'revision',
	INSPECTION_COMPLETED = 'inspection-completed',
	INSPECTION_COMPLETE = 'inspection-complete',
	COMPLETED_INSPECTION = 'completed-inspection',
	ASSIGNVENDOR = 'assign-vendor',
	OFFHOLD = 'offhold',
	ACCEPTED = 'accepted',
	ACCEPTED_WITH_CONDITIONS = 'accepted-with-conditions',
	ACCEPT_WITH_CONDITIONS = 'accept-with-conditions',
	ACCEPTED_BY_APPRAISER = 'accepted-by-appraiser',
	ACCEPT = 'accept',
	ADD_COMMENT = 'add-comment',
	ADD_ATTACHMENT = 'add-attachment',
	ADD_REPORT = 'add-report',
	ADDNOTE = 'addnote',
	ADD_NOTE = 'add-note',
	AMC_ACCEPTED = 'accepted',
	FAILED = 'decline',
	UNDERREVIEW = 'under-review',
	NOTE = 'notes',
	COMPLETED = 'completed',
	COMPLETE = 'complete',
	COMPLETION_DATE = 'completion-date',
	APPOINTMENTCREATED = 'appraiser/appointment',
	APPOINTMENTUPDATED = 'appraiser/appointment"',
	APPRAISALASSIGNED = 'assign-appraiser',
	APPOINTMENT_SCHEDULED = 'appointment-scheduled',
	ON_HOLD = 'on-hold',
	ONHOLD = 'onhold',
	UPLOADDOCUMENT = 'documents',
	REFUND = 'refund',
	REVISIONCLEARED = 'revision-clear',
	REVISIONSCOMPLETEDNODOC = 'revision-completed-nodoc',
	REVISIONSCOMPLETEDDOC = 'revision-completed-doc',
	REVISION_REQUIRED = 'revision-required',
	REVISION_RECEIVED = 'revision-received',
	NOTIFYDUEDATE = 'due-date',
	CANCEL = 'cancel',
	CANCELLED = 'cancel',
	DECLINE = 'decline',
	DECLINED = 'decline',
	NOTIFYAPPOINTMENT = 'notify-appointment',
	RESUME = 'resume',
	RESUME_ONHOLD = 'resume-onhold',
	NOTECOMPLETED = 'note-as-completed',
	// Start endpoint xpanse update status
	UPDATESTATUS_CANCEL = 'updatestatus-cancel',
	UPDATESTATUS_CANCEL_CONFIRMED = 'updatestatus-cancel-confirmed',
	UPDATESTATUS_DELIVER_PRODUCT = 'updatestatus-deliver-product',
	UPDATESTATUS_DENY_ORDER = 'updatestatus-deny-order',
	UPDATESTATUS_ESCALATION = 'updatestatus-escalation',
	UPDATESTATUS_ESCALATION_RESPONSE = 'updatestatus-escalation-response',
	UPDATESTATUS_REOPEN_APPROVED = 'updatestatus-reopen-approved',
	UPDATESTATUS_REOPEN_REQUEST = 'updatestatus-reopen-request',
	UPDATESTATUS_QC_CORRECTION_COMPLETE = 'updatestatus-qc-correction-complete',
	UPDATESTATUS_QC_CORRECTION_PENDING = 'updatestatus-qc-correction-pending',
	UPDATESTATUS_REQUEST_CANCELLATION = 'updatestatus-request-cancellation',
	UPDATESTATUS_REQUEST_REVISION = 'updatestatus-request-revision',
	UPDATESTATUS_RESUME = 'updatestatus-resume',
	UPDATESTATUS_REVISED_DELIVER_PRODUCT = 'updatestatus-revised-deliver-product',
	UPDATESTATUS_REVISION_REQUEST_APPROVED = 'updatestatus-revision-request-approved',
	UPDATESTATUS_REVISION_REQUEST_NOT_APPROVED = 'updatestatus-revision-request-not-approved',
	UPDATESTATUS_SUSPEND_ORDER = 'updatestatus-suspend-order',
	UPDATESTATUS = 'updatestatus',
	CALLBACK_UPDASTATUS_CANCEL = 'callback-updatestatus-cancel',
	CALLBACK_UPDASTATUS_CANCEL_CONFIRMED = 'callback-updatestatus-cancel-confirmed',
	CALLBACK_UPDASTATUS_DELIVER_PRODUCT = 'callback-updatestatus-deliver-product',
	CALLBACK_UPDASTATUS_DENY_ORDER = 'callback-updatestatus-deny-order',
	CALLBACK_UPDASTATUS_ESCALATION = 'callback-updatestatus-escalation',
	CALLBACK_UPDASTATUS_ESCALATION_RESPONSE = 'callback-updatestatus-escalation-response',
	CALLBACK_UPDASTATUS_REOPEN_APPROVED = 'callback-updatestatus-reopen-approved',
	CALLBACK_UPDASTATUS_REOPEN_REQUEST = 'callback-updatestatus-reopen-request',
	CALLBACK_FEEMODIFICATIONAPPROVED = 'callback-feemodificationapproved',
	CALLBACK_UPDASTATUS_QC_CORRECTION_COMPLETE = 'callback-updatestatus-qc-correction-complete',
	CALLBACK_UPDASTATUS_QC_CORRECTION_PENDING = 'callback-updatestatus-qc-correction-pending',
	CALLBACK_UPDASTATUS_REQUEST_CANCELLATION = 'callback-updatestatus-request-cancellation',
	CALLBACK_UPDASTATUS_REQUEST_REVISION = 'callback-updatestatus-request-revision',
	CALLBACK_UPDASTATUS_RESUME = 'callback-updatestatus-resume',
	CALLBACK_UPDASTATUS_REVISED_DELIVER_PRODUCT = 'callback-updatestatus-revised-deliver-product',
	CALLBACK_UPDASTATUS_REVISED_REQUEST_APPROVED = 'callback-updatestatus-revised-request-approved',
	CALLBACK_UPDASTATUS_REVISED_REQUEST_NOT_APPROVED = 'callback-updatestatus-revised-request-not-approved',
	CALLBACK_UPDASTATUS_SUSPEND_ORDER = 'callback-updatestatus-suspend-order',
	CALLBACK_UPDASTATUS_VENDOR_QC = 'callback-updatestatus-vendor-qc',
	CALLBACK_UPDASTATUS = 'callback-updatestatus',
	CALLBACK_NEWORDER = 'callback-neworder',
	// End endpoint xpanse update status
	ADDATTACHMENT = 'addattachment',
	ASSIGNED_INFORMATION = 'assigned-information',
	REQUEST_FHA_NUMBER = 'request-fha-number',
	SCHEDULE = 'schedule',
	SCHEDULED = 'scheduled',
	SCHEDULE_INSPECTION = 'schedule-inspection',
	INSPECTED = 'inspected',
	FEE_MODIFICATION = 'fee-modification',
	FINAL_INVOICE = 'final-invoice',
	FULLCOMPLETED = 'full-completed',
	CALLBACK_NEWDOCUMENT = 'callback-newdocument',
	CALLBACK_PLACEORDER = 'callback-placeorder',
	CALLBACK_EXPEDITEORDERAPPROVED = 'callback-expediteorderapproved',
	CALLBACK_NOTE = 'callback-note',
	CALLBACK_NOTE_ACK = 'callback-note-ack',
	CALLBACK_ORDERUPDATED = 'callback-orderupdated',
	CALLBACK_FEE_MODIFICATION_NOT_APPROVED = 'callback-fee-modification-not-approved',
	// End endpoint order external retry
	CALLBACK_UPDATESTATUS = 'ordersExternal/StatusChanged',
	CALLBACK_UPLOADDOCUMENTS = 'ordersExternal/NewAttachments',
	CALLBACK_SETAPPOINMENT = 'ordersExternal/SetAppoinment',
	CALLBACK_NOTES = 'ordersExternal/NewNotes',
	CALLBACK_SCANNER = 'ordersExternal/ScanEvents',
	CALLBACK_DESKTOP_EVENTS = 'ordersExternal/DesktopEvents',
	CALLBACK_ASSIGNED_TO_VENDOR = 'ordersExternal/AssignVendorEvents',
	CALLBACK_CLIENT_FEE_CHANGED = 'ordersExternal/ClientFeeChanged',
	CALLBACK_CLIENT_DUE_DATE = 'ordersExternal/ClientDueDateChanged',
	CALLBACK_PAYMENT_LINK_SENT_BORROWER = 'ordersExternal/PaymentLinkSentToBorrower',
	CALLBACK_CUSTOM_FIELD_SET = 'ordersExternal/OrderCustomFieldSet',
	MODIFICATION_REQUEST = 'modification-request',
	INSPECTION_SCHEDULE = "inspection-schedule",
	ADD_DOCUMENT = "add-attachment",
	PAYMENT_RECEIVED = 'payment-received',
	SATISFY_CONDITION_WITH_FILE = 'satisfy-condition-with-file',
	SATISFY_CONDITION_WITH_COMMENT = 'satisfy-condition-with-comment',
	FEE_CHANGE = 'fee-change',
	ROV = 'rov',
	PROJECTEDCOMPLETIONDATE = 'projected-completiondate',
	PLACE_ORDER_FAILED = 'place-order-failed',
	RESUME_ON_HOLD = 'offhold',
	LATE = 'late',
	QUALITY_CONTROL = 'quality-control',
	ACCEPTEDBYAPPRAISER = "accepted-by-appraiser",
}

export enum ORIGIN {
    Nexsys = 'Nexsys',
    NexsysLegacy = 'Nexsys Legacy',
    Valutrust = 'Valutrust',
    Xpanse = 'Xpanse',
    OrderExternal = 'Order External',
    FNC = 'FNC',
    EVO = 'EVO',
	ValueLinkLender = 'ValueLinkLender',
    ValueLink = 'ValueLink',
	Connexions = 'Connexions',
	Lendingqb = 'LendingQb',
	LandGorilla = 'LandGorilla',
	Fics = 'Fics',
	LendingPad = 'LendingPad',
}

export const URLS = {
	NEXSYS: 'nexsys-monitor',
	NEXSYS_ORPHAN: 'nexsys-legacy-monitor',
	NEXSYS_LEGACY: 'nexsys-legacy-monitor', // for the sake of the new method
	VALUTRUST: 'valutrust-monitor',
	XPANSE: 'xpanse-monitor',
	ORDER_EXTERNAL: 'order-external-monitor',
	ORDERS_EXTERNAL: 'order-external-monitor', // for the sake of the new method
	FNC: 'fnc-monitor',
	EVO: 'evo-monitor',
	MI_MUTUAL: 'mi-mutual',
	RELIANCE_FIRST: 'reliance-first',
	VALUELINK: 'valuelink-monitor',
	VALUELINK_LENDER: 'valuelink-lender-monitor',
	CONNEXIONS: 'connexions-monitor',
	LENDINGQB: 'lending-qb-monitor',
	LANDGORILLA: 'landgorilla-monitor',
	FICS: 'fics-monitor',
	LENDINGPAD: 'lendingpad-monitor'
};

export const URLS_FIELDS = {
	NEXSYS: 'providerId',
	NEXSYS_ORPHAN: 'providerId',
	NEXSYS_LEGACY: 'providerId', // for the sake of the new method
	VALUTRUST: 'providerId',
	XPANSE: [
		'providerTransId',
		'providerId'
	],
	ORDER_EXTERNAL: 'id',
	ORDERS_EXTERNAL: 'id', // for the sake of the new method
	FNC: 'providerId',
	EVO: 'providerId',
	MI_MUTUAL: 'N/A',
	RELIANCE_FIRST: 'N/A',
	VALUELINK: [
		'providerId',
		'providerClientId'
	],
	VALUELINK_LENDER: 'id',
	CONNEXIONS: 'id',
	LENDINGQB: 'id',
	LANDGORILLA: 'id',
	FICS: 'id',
	LENDINGPAD: 'id'
};

export const SUBURLS = {
	LOGS: 'logs',
	ORDERS: 'orders',
	ORDERLOGS: 'order-log'
};

export const LOGS = {
	ORDER: 'Order',
	ORDERSEXTERNAL: 'Order External',
	NEXSYS: 'Nexsys',
	VALUTRUST: 'Valutrust',
	XPANSE: 'Xpanse',
	ADDENDUM: 'Addendum',
	ASSOCIATED_LOGS: 'Associated logs',
	ASSOCIATED_ADDENDUM_LOGS: 'Associated Adde.',
	FNC: 'FNC',
	EVO: 'EVO',
	VALUELINK_LENDER: 'ValueLinkLender',
	VALUELINK: 'ValueLink',
	CONNEXIONS: 'Connexions',
	LENDINGQB: 'LendingQb',
	LANDGORILLA: 'LandGorilla',
	FICS: 'Fics',
	LENDINGPAD: 'LendingPad'
};
